import React, { useState, useEffect, useContext, useRef } from "react";
import heroGif from "../img/hero3.avifs"; // GIF dosyas��n��n yolu
import heroStatic from "../img/hero-static2.avif";
import heroArtWork from "../img/artwork2.avif";
import HomepageContext from "../context/HeroContext";
import heroReverse from "../img/hero-reverse4.avifs";
import { useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import LoadingPage from "../pages/LoadingPage";

const HERO_UNLOCK_KEY = "isLoad";
const getInitialUnlockState = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(HERO_UNLOCK_KEY) === "true";
  } catch (error) {
    console.error("Unable to read unlock state:", error);
    return false;
  }
};

function Hero({ isLoading }) {
  const { value, setValue } = useContext(HomepageContext);
  const [showStatic, setShowStatic] = useState(false);
  const [showArtwork, setShowArtwork] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [reverse, setReverse] = useState(false);
  const [loading, setLoading] = useState(true); // YǬkleme durumunu izleyen state
  const [hasUnlocked, setHasUnlocked] = useState(getInitialUnlockState);
  const navigate = useNavigate();
  const unlockTimerRef = useRef(null);

  const toggleScrollLock = (locked) => {
    if (typeof document === "undefined") {
      return;
    }

    document.body.style.overflowY = locked ? "hidden" : "auto";
    const header = document.getElementById("header");
    const header2 = document.getElementById("header2");

    if (header) {
      header.style.opacity = locked ? "0" : "1";
    }
    if (header2) {
      header2.style.opacity = locked ? "0" : "1";
    }
  };

  // Preload the initial images using Image constructor
  useEffect(() => {
    if (hasUnlocked) {
      setLoading(false);
      return;
    }

    toggleScrollLock(true);

    if (typeof document === "undefined") {
      setLoading(false);
      return;
    }

    const loadImage = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = reject;
      });
    };

    const images = Array.from(document.querySelectorAll("img")).map(
      (img) => img.src
    );
    loadImage(heroGif);
    Promise.all(images.map((src) => loadImage(src)))
      .then(() => setLoading(false))
      .catch((err) => {
        console.error("Failed to load images", err);
        setLoading(false);
      });

    return () => {
      if (!hasUnlocked) {
        toggleScrollLock(false);
      }
    };
  }, [hasUnlocked]);

  // YǬkleme tamamland��ktan sonra di�Yer resimleri yǬkle
  useEffect(() => {
    if (!loading && !hasUnlocked) {
      const loadImage = (src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = reject;
        });
      };

      Promise.all([loadImage(heroArtWork), loadImage(heroReverse)]).catch(
        (err) => {
          console.error("Failed to load additional images", err);
        }
      );
    }
  }, [loading, hasUnlocked]);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (hasUnlocked) {
      setShowStatic(false);
      setShowOverlay(false);
      setShowGif(true);
      setValue(true);
      setShowArtwork(true);
      toggleScrollLock(false);

      return () => {
        toggleScrollLock(false);
      };
    }

    toggleScrollLock(true);

    const timer = setTimeout(() => {
      setShowGif(true);
      setShowStatic(true);
      setShowOverlay(true);
    }, 2500);

    return () => {
      clearTimeout(timer);
      toggleScrollLock(false);
    };
  }, [hasUnlocked, loading, setValue]);

  const changeValue = () => {
    setReverse(true);
    setShowStatic(false);
    setShowOverlay(false);
    setShowArtwork(true);

    if (typeof window !== "undefined") {
      try {
        window.localStorage.setItem(HERO_UNLOCK_KEY, "true");
      } catch (error) {
        console.error("Unable to persist unlock state:", error);
      }
    }

    if (unlockTimerRef.current) {
      clearTimeout(unlockTimerRef.current);
    }

    unlockTimerRef.current = setTimeout(() => {
      setValue(true);
      setReverse(false);
      setHasUnlocked(true);
      toggleScrollLock(false);
      unlockTimerRef.current = null;
    }, 2500);
  };

  useEffect(() => {
    return () => {
      if (unlockTimerRef.current) {
        clearTimeout(unlockTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const { hash, state } = window.location;

    if (hash) {
      scroller.scrollTo(hash.replace("#", ""), {
        duration: 800,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }

    if (state && state.from) {
      console.log(`Navigated from ${state.from}`);
      // Ba�Yka bir sayfadan geldiyseniz yap��lacak i�Ylemler
      setReverse(false);
      setShowStatic(false);
      setShowOverlay(false);
      setShowArtwork(true);
    }
  }, [navigate]);

  if (loading) {
    return <LoadingPage />; // YǬklenme s��ras��nda g��sterilecek preloader
  }

  return (
    <div
      className={`relative w-full h-screen ${
        value ? "mobile:h-[100vh]" : "mobile:h-[100vh]"
      }  mobile:h-[100vh] `}
    >
      <img
        src={heroGif}
        alt="Hero"
        className={`absolute w-full h-full object-cover ${
          showGif ? "hidden" : "block"
        }`}
      />
      <img
        src={heroStatic}
        alt="Hero Static"
        className={`relative w-full h-full object-cover ${
          showStatic ? "block" : "hidden"
        }`}
      />
      <img
        src={heroReverse}
        alt="hero reverse"
        className={`absolute w-full h-[100vh] object-cover ${
          reverse ? "block" : "hidden"
        }`}
      />
      <img
        src={heroArtWork}
        alt="Hero Static"
        className={`w-full h-full object-cover ${
          showArtwork ? "block" : "hidden"
        }`}
      />
      <div
        className={`absolute inset-0 flex flex-col items-center justify-center p-4 transition-opacity duration-1000 ${
          showOverlay ? "opacity-100 block" : "opacity-0 hidden"
        }`}
      >
        <div
          className={`transition-opacity duration-1000 delay-100 ${
            showOverlay ? "opacity-100" : "opacity-0"
          }`}
        >
          <h3 className="text-white font-semibold text-5xl 2xl:text-8xl text-center">
            we pump
          </h3>
        </div>
        <div
          className={`mt-2 2xl:mt-10 mobile:w-3/4 mobile:mt-10 w-1/3 font-semibold transition-opacity duration-1000 delay-200 ${
            showOverlay ? "opacity-100" : "opacity-0"
          }`}
        >
          <p className="text-white font-medium text-sm lg:text-base text-center">
            <h1>The #1 Awarded Growth Architecture Agency in Web3</h1>
          </p>
        </div>
        <div
          className={`transition-opacity duration-1000 delay-300 ${
            showOverlay ? "opacity-100" : "opacity-0"
          }`}
        >
          <button
            className="rounded-full font-semibold mt-10 bg-white py-2 text-lg px-5"
            onClick={() => changeValue()}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}

export default Hero;
